module.exports = __webpack_public_path__ + "img/项目时间点.d2f30d0a.svg";